function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: "1em",
  width: "1em",
  viewBox: "0 0 256 256",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  strokeWidth: "15",
  stroke: "#000",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  rx: "12",
  height: "166",
  width: "167",
  y: "25",
  x: "25",
  strokeDasharray: "35"
}), /*#__PURE__*/React.createElement("rect", {
  rx: "12",
  height: "166",
  width: "167",
  y: "70",
  x: "70"
}))));